export default __webpack_public_path__ + "static/tyre_insurance_2-a96e22b8d1266d7eee24eb9c441d0d35.webp";